var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSliderPhotoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.36563 8.48436C9.85233 8.48436 10.2469 8.08981 10.2469 7.60311C10.2469 7.11641 9.85233 6.72186 9.36563 6.72186C8.87892 6.72186 8.48438 7.11641 8.48438 7.60311C8.48438 8.08981 8.87892 8.48436 9.36563 8.48436Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0312 4.96875V19.0312H4.96875V20.7891H20.7891V4.96875H19.0312Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2734 3.21094H3.21094V17.2734H17.2734V3.21094ZM15.5156 12L12 8.48438L9.80156 10.6828L8.48438 9.36563L4.96875 12.8812V4.96875H15.5156V12Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderPhotoIcon);
export default __webpack_public_path__ + "static/media/SliderPhotoIcon.cab4bd6eab0216952327cacee7e15bef.svg";
export { ForwardRef as ReactComponent };